/**
 * A global namespace for aria-expanded.
 */
const ariaExpanded = 'aria-expanded';
export default ariaExpanded;
